import {
  Badge,
  Box,
  Button,
  Card,
  Divider,
  Flex,
  Group,
  NumberInput,
  rem,
  Stack,
  Table,
  Title,
} from "@mantine/core";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { useEffect, useState } from "react";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { IconCheck, IconEdit, IconX } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface DiscountLevel {
  id: number;
  discountLevel1: number | null;
  discountLevel2: number | null;
  discountLevel3: number | null;
  type: string | null;
  createdBy: string | null;
  createdDate: string | Date | null;
  lastUpdatedBy: string | null;
  lastUpdatedDate: string | Date | null;
}

interface EditDiscountLevel {
  id: number;
  discountLevel1: number | null;
  discountLevel2: number | null;
  discountLevel3: number | null;
}

interface NumberOfPurchase {
  id: number;
  numberOfPurchase1: number | null;
  numberOfPurchase2: number | null;
  numberOfPurchase3: number | null;
  createdBy: string | null;
  createdDate: string | Date | null;
  lastUpdatedBy: string | null;
  lastUpdatedDate: string | Date | null;
}

interface EditNumberOfPurchase {
  id: number;
  numberOfPurchase1: number | null;
  numberOfPurchase2: number | null;
  numberOfPurchase3: number | null;
}

const SetUpDiscounts = () => {
  //#region data
  const [dataDiscountLevel, setDataDiscountLevel] = useState<DiscountLevel[]>(
    []
  );
  const [dataNumberOfPurchase, setDataNumberOfPurchase] =
    useState<NumberOfPurchase>();

  //#region state
  const [tableEdit, setTableEdit] = useState<string>("");
  const [indexTb, setIndexTb] = useState<number>(-1);

  //#region useForm
  const formDiscountLevel = useForm<EditDiscountLevel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      discountLevel1: 0,
      discountLevel2: 0,
      discountLevel3: 0,
    },

    validate: {
      discountLevel1: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập doanh thu 1 !";
        }

        if (value && values.discountLevel2 && value > values.discountLevel2) {
          return "Doanh thu 1 không được lớn hơn doanh thu 2 !";
        }
      },
      discountLevel2: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập doanh thu 2 !";
        }

        if (value && values.discountLevel3 && value > values.discountLevel3) {
          return "Doanh thu 2 không được lớn hơn doanh thu 3 !";
        }

        if (value && values.discountLevel1 && value < values.discountLevel1) {
          return "Doanh thu 2 không được nhỏ hơn doanh thu 1 !";
        }
      },
      discountLevel3: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập doanh thu 3 !";
        }

        if (value && values.discountLevel2 && value < values.discountLevel2) {
          return "Doanh thu 3 không được nhỏ hơn doanh thu 2 !";
        }
      },
    },
  });

  const formNumberOfPurchase = useForm<EditNumberOfPurchase>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      numberOfPurchase1: 0,
      numberOfPurchase2: 0,
      numberOfPurchase3: 0,
    },

    validate: {
      numberOfPurchase1: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập số lần mua hàng 1 !";
        }

        if (
          value &&
          values.numberOfPurchase2 &&
          value > values.numberOfPurchase2
        ) {
          return "Số lần mua hàng 1 không được lớn hơn số lần mua hàng 2 !";
        }
      },
      numberOfPurchase2: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập số lần mua hàng 2 !";
        }

        if (
          value &&
          values.numberOfPurchase3 &&
          value > values.numberOfPurchase3
        ) {
          return "Số lần mua hàng 2 không được lớn hơn số lần mua hàng 3 !";
        }

        if (
          value &&
          values.numberOfPurchase1 &&
          value < values.numberOfPurchase1
        ) {
          return "Số lần mua hàng 2 không được nhỏ hơn số lần mua hàng 1 !";
        }
      },
      numberOfPurchase3: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng nhập số lần mua hàng 3 !";
        }

        if (
          value &&
          values.numberOfPurchase2 &&
          value < values.numberOfPurchase2
        ) {
          return "doanh thu 3 không được nhỏ hơn doanh thu 2 !";
        }
      },
    },
  });

  const updateDataDiscountLevel = (index: number, newValue: DiscountLevel) => {
    setDataDiscountLevel((prev: any) => {
      const newProduct = [...prev];
      newProduct[index] = newValue;
      return newProduct;
    });
  };

  const getDataDiscountLevel = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDiscountLevel/get-discount-level"
    );

    if (res && res.success) {
      const result = res.data;
      setDataDiscountLevel(result);
    }
  };

  const handleEditDiscountLevel = async (
    index: number,
    dataSubmit: EditDiscountLevel
  ) => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblDiscountLevel/update",
      dataSubmit
    );

    if (res && res.success) {
      NotificationExtension.Success("Cập nhật doanh thu thành công !");
      setTableEdit("");
      setIndexTb(-1);
      updateDataDiscountLevel(index, {
        id: dataSubmit?.id,
        discountLevel1: dataSubmit?.discountLevel1,
        discountLevel2: dataSubmit?.discountLevel2,
        discountLevel3: dataSubmit?.discountLevel3,
        type: dataDiscountLevel[index]?.type ?? null,
        createdBy: dataDiscountLevel[index]?.createdBy ?? null,
        createdDate: dataDiscountLevel[index]?.createdDate ?? null,
        lastUpdatedBy: dataDiscountLevel[index]?.lastUpdatedBy ?? null,
        lastUpdatedDate: dataDiscountLevel[index]?.lastUpdatedDate ?? null,
      });
    }
  };

  const getDataNumberOfPurchase = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblNumberOfPurchase/get-number-of-purchase"
    );

    if (res && res.success) {
      const result = res.data;
      setDataNumberOfPurchase(result);
    }
  };

  const handleEditNumberOfPurchase = async (
    dataSubmit: EditNumberOfPurchase
  ) => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblNumberOfPurchase/update",
      dataSubmit
    );

    if (res && res.success) {
      NotificationExtension.Success("Cập nhật số lần mua hàng thành công !");
      setTableEdit("");
      setDataNumberOfPurchase((prev: any) => ({
        ...prev,
        numberOfPurchase1: dataSubmit?.numberOfPurchase1,
        numberOfPurchase2: dataSubmit?.numberOfPurchase2,
        numberOfPurchase3: dataSubmit?.numberOfPurchase3,
      }));
    }
  };

  useEffect(() => {
    getDataDiscountLevel();
    getDataNumberOfPurchase();
  }, []);

  return (
    <>
      <_breadcrumb />
      <Stack gap="xl" mt="md">
        <Card
          shadow="md"
          radius="lg"
          p="xl"
          style={{
            background: "linear-gradient(135deg, #f8fafc 60%, #e0e7ff 100%)",
          }}
        >
          <Group justify="space-between" mb="md">
            <Title order={3} fw={700} c="#2B3276">
              Thiết lập doanh thu
            </Title>
            {/* <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2B3276", deg: 90 }}
              size="lg"
            >
              Doanh thu
            </Badge> */}
          </Group>
          <Divider mb="md" />
          <Table
            striped
            highlightOnHover
            withTableBorder
            withColumnBorders
            verticalSpacing="md"
            horizontalSpacing="md"
            style={{ borderRadius: rem(12), overflow: "hidden" }}
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th ta="center">Doanh thu 1</Table.Th>
                <Table.Th ta="center">Doanh thu 2</Table.Th>
                <Table.Th ta="center">Doanh thu 3</Table.Th>
                <Table.Th ta="center">Áp dụng</Table.Th>
                <Table.Th ta="center">Thao tác</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {dataDiscountLevel?.map((item, index) => (
                <Table.Tr key={item.id}>
                  <Table.Td ta="center">
                    {indexTb !== index ? (
                      <b style={{ color: "#2B3276" }}>
                        {item.discountLevel1?.toLocaleString()} VNĐ
                      </b>
                    ) : (
                      <NumberInput
                        key={formDiscountLevel.key("discountLevel1")}
                        hideControls
                        placeholder="Nhập doanh thu 1"
                        suffix=" VNĐ"
                        allowNegative={false}
                        thousandSeparator=","
                        min={0}
                        {...formDiscountLevel.getInputProps("discountLevel1")}
                      />
                    )}
                  </Table.Td>
                  <Table.Td ta="center">
                    {indexTb !== index ? (
                      <b style={{ color: "#2B3276" }}>
                        {item.discountLevel2?.toLocaleString()} VNĐ
                      </b>
                    ) : (
                      <NumberInput
                        key={formDiscountLevel.key("discountLevel2")}
                        hideControls
                        placeholder="Nhập doanh thu 2"
                        suffix=" VNĐ"
                        allowNegative={false}
                        thousandSeparator=","
                        min={0}
                        {...formDiscountLevel.getInputProps("discountLevel2")}
                      />
                    )}
                  </Table.Td>
                  <Table.Td ta="center">
                    {indexTb !== index ? (
                      <b style={{ color: "#2B3276" }}>
                        {item.discountLevel3?.toLocaleString()} VNĐ
                      </b>
                    ) : (
                      <NumberInput
                        key={formDiscountLevel.key("discountLevel3")}
                        hideControls
                        placeholder="Nhập doanh thu 3"
                        suffix=" VNĐ"
                        allowNegative={false}
                        thousandSeparator=","
                        min={0}
                        {...formDiscountLevel.getInputProps("discountLevel3")}
                      />
                    )}
                  </Table.Td>
                  <Table.Td ta="center">
                    {Number(item.type) === 2 ? (
                      <Badge color="blue" size="md">
                        Bán lẻ
                      </Badge>
                    ) : (
                      <Badge color="green" size="md">
                        Bán buôn
                      </Badge>
                    )}
                  </Table.Td>
                  <Table.Td ta="center" w={225}>
                    {index === indexTb && tableEdit === "doanhThu" ? (
                      <Group gap="sm" justify="center">
                        <Button
                          leftSection={<IconX />}
                          color="red"
                          variant="light"
                          onClick={() => {
                            setIndexTb(-1);
                            setTableEdit("");
                          }}
                        >
                          Hủy
                        </Button>
                        <Button
                          leftSection={<IconCheck />}
                          color="teal"
                          variant="filled"
                          onClick={() => {
                            handleEditDiscountLevel(
                              index,
                              formDiscountLevel.getValues()
                            );
                          }}
                        >
                          Lưu
                        </Button>
                      </Group>
                    ) : (
                      <Button
                        leftSection={<IconEdit />}
                        color="yellow"
                        variant="light"
                        onClick={() => {
                          setIndexTb(index);
                          setTableEdit("doanhThu");
                          formDiscountLevel.setValues({
                            id: item.id,
                            discountLevel1: item.discountLevel1,
                            discountLevel2: item.discountLevel2,
                            discountLevel3: item.discountLevel3,
                          });
                        }}
                      >
                        Sửa
                      </Button>
                    )}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Card>

        <Card
          shadow="md"
          radius="lg"
          p="xl"
          style={{
            background: "linear-gradient(135deg, #f8fafc 60%, #bbf7d0 100%)",
          }}
          component="form"
          onSubmit={formNumberOfPurchase.onSubmit((e: EditNumberOfPurchase) => {
            handleEditNumberOfPurchase(e);
          })}
        >
          <Group justify="space-between" mb="md">
            <Title order={3} fw={700} c="#15803d">
              Thiết lập số lần mua hàng
            </Title>
            {/* <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2B3276", deg: 90 }}
              size="lg"
            >
              Số lần mua hàng
            </Badge> */}
          </Group>
          <Divider mb="md" />
          <Table
            striped
            highlightOnHover
            withTableBorder
            withColumnBorders
            verticalSpacing="md"
            horizontalSpacing="md"
            style={{ borderRadius: rem(12), overflow: "hidden" }}
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th ta="center">Số lần mua hàng 1</Table.Th>
                <Table.Th ta="center">Số lần mua hàng 2</Table.Th>
                <Table.Th ta="center">Số lần mua hàng 3</Table.Th>
                <Table.Th ta="center">Áp dụng</Table.Th>
                <Table.Th ta="center">Thao tác</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <Table.Tr>
                <Table.Td ta="center">
                  {tableEdit !== "soLanMuaHang" ? (
                    <b style={{ color: "#15803d" }}>
                      {Number(dataNumberOfPurchase?.numberOfPurchase1)}
                    </b>
                  ) : (
                    <NumberInput
                      key={formNumberOfPurchase.key("numberOfPurchase1")}
                      hideControls
                      placeholder="Nhập số lần mua hàng 1"
                      min={0}
                      {...formNumberOfPurchase.getInputProps(
                        "numberOfPurchase1"
                      )}
                    />
                  )}
                </Table.Td>
                <Table.Td ta="center">
                  {tableEdit !== "soLanMuaHang" ? (
                    <b style={{ color: "#15803d" }}>
                      {Number(dataNumberOfPurchase?.numberOfPurchase2)}
                    </b>
                  ) : (
                    <NumberInput
                      key={formNumberOfPurchase.key("numberOfPurchase2")}
                      hideControls
                      placeholder="Nhập số lần mua hàng 2"
                      min={0}
                      {...formNumberOfPurchase.getInputProps(
                        "numberOfPurchase2"
                      )}
                    />
                  )}
                </Table.Td>
                <Table.Td ta="center">
                  {tableEdit !== "soLanMuaHang" ? (
                    <b style={{ color: "#15803d" }}>
                      {Number(dataNumberOfPurchase?.numberOfPurchase3)}
                    </b>
                  ) : (
                    <NumberInput
                      key={formNumberOfPurchase.key("numberOfPurchase3")}
                      hideControls
                      placeholder="Nhập số lần mua hàng 3"
                      min={0}
                      {...formNumberOfPurchase.getInputProps(
                        "numberOfPurchase3"
                      )}
                    />
                  )}
                </Table.Td>
                <Table.Td ta="center">
                  <Badge color="green" size="md">
                    Bán buôn
                  </Badge>
                </Table.Td>
                <Table.Td ta="center" w={225}>
                  {tableEdit === "soLanMuaHang" ? (
                    <Group gap="sm" justify="center">
                      <Button
                        leftSection={<IconX />}
                        color="red"
                        variant="light"
                        onClick={() => setTableEdit("")}
                      >
                        Hủy
                      </Button>
                      <Button
                        leftSection={<IconCheck />}
                        color="teal"
                        variant="filled"
                        type="submit"
                      >
                        Lưu
                      </Button>
                    </Group>
                  ) : (
                    <Button
                      leftSection={<IconEdit />}
                      color="yellow"
                      variant="light"
                      onClick={() => {
                        setTableEdit("soLanMuaHang");
                        formNumberOfPurchase.setValues({
                          id: dataNumberOfPurchase?.id,
                          numberOfPurchase1:
                            dataNumberOfPurchase?.numberOfPurchase1,
                          numberOfPurchase2:
                            dataNumberOfPurchase?.numberOfPurchase2,
                          numberOfPurchase3:
                            dataNumberOfPurchase?.numberOfPurchase3,
                        });
                      }}
                    >
                      Sửa
                    </Button>
                  )}
                </Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        </Card>
      </Stack>
    </>
  );
};

export default SetUpDiscounts;
